import { Text } from 'components';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Arrows } from '../../components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 76px;

  margin-bottom: 100px;

  position: relative;
  ${(props) => props.src && `background-image: url(${props.src})`};
  background-repeat: no-repeat;
  background-size: 100% 316px;
  background-position: 0 20px;

  @media (min-width: 1024px) {
    .mobile-heading {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    margin: 105px 0 35px;

    h4 {
      font-size: 30px;
      color: ${theme.SECONDARY};
      font-weight: 500;
      margin: 0 17px 28px;
    }
  }
`;

const BgsContainer = styled.div`
  position: absolute;
  width: 100vw;
  display: flex;
  flex-direction: column;
  z-index: 1;
  top: -20px;
`;

const RedBg = styled.div`
  height: 464px;
  width: 1280px;
  background-color: ${theme.SECONDARY};
  align-self: center;

  @media (max-width: 1024px) {
    margin-top: 4px;
    width: 100vw;
    height: 397px;
  }
`;

const GreenBg = styled.div`
  height: 183px;
  width: 100%;
  background-color: black;

  @media (max-width: 1024px) {
    width: 100vw;
    height: 102px;
  }
`;

const ContentContainer = styled.div`
  z-index: 2;
  display: flex;
  flex-direction: column;
`;

const HeaderImage = styled.img`
  margin: 25px 0 0;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const ScrollContainer = styled.div`
  ${navigator.platform !== 'Win32' ? 'overflow-x: scroll;' : 'overflow-x: hidden;'}
  padding-left: ${(props) => props.extraPad};
  display: flex;
  margin-top: 24px;

  @media (max-width: 1024px) {
    margin-top: 25px;
    padding-left: 17px;
    overflow-x: scroll;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  width: 1140px;
  align-self: center;
  position: relative;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const AthleteFocusHeader = styled.div`
  margin-left: 9px;

  h4 {
    font-size: 30px;
    font-weight: 500;
    color: ${theme.SECONDARY};
  }

  h3 {
    font-size: 72px;
    line-height: 54px;
    margin-top: 19px;
    letter-spacing: -3.5px;
  }

  @media (max-width: 1024px) {
    margin-top: 1px;
    margin-left: 0;

    .desktop-h3 {
      display: none;
    }

    .mobile-h3 {
      margin-top: 58px;
      h3 {
        margin-top: 0;
        margin-left: 13px;
        font-size: 48px;
        line-height: 37.44px;
        letter-spacing: -1.5px;
        color: white;
      }
    }

    h4 {
      display: none;
    }
  }

  @media (min-width: 1024px) {
    .mobile-h3  {
      display: none;
    }
  }
`;

const HeaderText = styled(Text)`
  margin: 20px 0 0;

  @media (max-width: 1024px) {
    margin: 0 13px;
    font-size: 16px;
  }
`;

const AthleteItem = styled.div`
  width: 330px;
  margin-right: 40px;

  img {
    width: 330px;
    height: 330px;
    margin-bottom: 12px;
  }

  h5  {
    width: 294px;
    font-weight: 400;
    color: #fff;
    font-size: 20px;
  }

  p  {
    font-size: 22px;
  }

  @media (max-width: 1024px) {
    width: 240px;
    margin-right: 30px;

    img {
      width: 240px;
      height: 240px;
      margin-bottom: 5px;
    }

    h5  {
      font-weight: 400;
      color: #fff;
      font-size: 16px;
    }

    p  {
      font-size: 16px;
    }
  }
`;

const ArrowsContainer = styled.div`
  position: absolute;
  right: -20px;
  top: 158px;
`;

const AthleteFocus = (props) => {
  const [extraPad, setExtraPad] = useState('0px'),
    scrollRef = useRef(null),
    { t } = useTranslation();

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  return null;

  return (
    <Container src={require('assets/images/fans-background.png')}>
      <ContentContainer>
        <HeaderRow>
          <AthleteFocusHeader>
            <HeaderText size="24px" col="white">
              {t('website.enjoyTheseMembership')}
            </HeaderText>
            <HeaderImage src={require('assets/images/sport-unites-no-divide.png')} />

            <div className="mobile-h3">
              <Text h3 stencil>
                {t('website.sportUnites')}
              </Text>
              <Text h3 stencil>
                {t('web.noDivide')}
              </Text>
            </div>
          </AthleteFocusHeader>

          <ArrowsContainer>
            <div className="absolute-arrows">
              <Arrows col="white" elem={scrollRef} />
            </div>
          </ArrowsContainer>
        </HeaderRow>

        <ScrollContainer extraPad={extraPad} ref={scrollRef}>
          <AthleteItem>
            <img src={require('assets/images/pogba.png')} alt="" />

            <Text h5>{t('website.videosArticles')}</Text>
          </AthleteItem>

          <AthleteItem>
            <img src={require('assets/images/pogba.png')} alt="" />

            <Text h5>{t('website.instantMessaging')}</Text>
          </AthleteItem>

          <AthleteItem>
            <img src={null} alt="" />

            <Text h5>{t('website.discountOnEvent')}</Text>
          </AthleteItem>

          <div>
            <AthleteItem>
              <img src={require('assets/images/pogba.png')} alt="" />

              <Text h5>{t('website.behindTheScenes')}</Text>
            </AthleteItem>
          </div>
        </ScrollContainer>
      </ContentContainer>

      <BgsContainer>
        <RedBg />
        <GreenBg />
      </BgsContainer>
    </Container>
  );
};

export default AthleteFocus;
